const transformCmsStorelocatorResponse = ({ _id , title , latitude , longitude , street , postcode , city , country , phone_1 , phone_2 , fax , email , website_url , additional_text , region , region_id , is_enabled_for_pickup_in_store , is_enabled_shop_details , store_external_iframe_appointment , additional_text_2 , marker_image_url , image_url , code , tags , images , working_times , available  })=>({
        id: _id,
        pickupId: parseInt(_id.split('_', 1)[0]),
        code,
        title,
        latitude,
        longitude,
        street,
        postcode,
        city,
        countryCode: country,
        phone1: phone_1,
        phone2: phone_2,
        fax,
        email,
        websiteUrl: website_url,
        markerImage: marker_image_url,
        region: region_id ? null : region,
        regionId: region_id ? parseInt(region_id) : null,
        pickupInStoreEnabled: is_enabled_for_pickup_in_store,
        isEnabledShopDetails: is_enabled_shop_details,
        additionalText: additional_text,
        additionalText2: additional_text_2,
        additionalText3: store_external_iframe_appointment,
        image: image_url,
        tags: tags.map(({ tag_id , name , description , image_url  })=>({
                id: tag_id,
                name,
                description: description || null,
                image: image_url || null
            })),
        images: images.map(({ image_id , title , description , image_url  })=>({
                id: image_id,
                title: title || null,
                description: description || null,
                image: image_url || null
            })),
        workingTimes: working_times.map(({ workingtime_id , day , period , from , to , closed  })=>({
                id: workingtime_id,
                day,
                period,
                from,
                to,
                closed: closed === 1
            })),
        availableInStore: available > 0 || false,
        qtyInStore: available || 0,
        urlKey: null
    });
const transformCmsStorelocatorsResponse = (data)=>data.map((store)=>transformCmsStorelocatorResponse(store));
const transformUpsapStoresResponse = (data)=>data.map(({ city , country_code , id , latitude , longitude , phone1 , pickup_id , postal_code , region , region_id , street , title  } = {})=>({
            city,
            countryCode: country_code,
            id,
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude),
            phone1,
            pickupId: pickup_id || id,
            pickupInStoreEnabled: true,
            postcode: postal_code,
            region: region ?? null,
            regionId: region_id ? parseInt(region_id) : null,
            street,
            title
        }));

export { transformCmsStorelocatorResponse, transformCmsStorelocatorsResponse, transformUpsapStoresResponse };
